module.exports = "https://retros.devl.appslatam.com/images/bullet.svg?633fb38c3857fb6f7f36ba2dc6270e5f";